export const usersTbl = "users";
export const orgsApplicationTbl = "orgzayavki";
export const organizationsTbl = "organizations";
export const staffTbl = "staff";
export const competencesTbl = "competences";
export const programsTbl = "eprograms";
export const programContentTbl = "eprog_content";
export const eduMenuTbl = "edumenu";
export const modulesTbl = "emodules";
export const moduleContentTbl = "emod_content";
export const lessonsTbl = "lessons";
export const learnersTbl = "learners";
export const pollsTbl = "polls_content";
export const coursesTbl = "courses";

export let basename = "";

export const siteUrl = "https://retaily.pro";

export const urlAPI = siteUrl + "/api/";
//export const urlAPI = siteUrl + "/apitest/";
//export const urlAPI = siteUrl + "/";

export const urlAdminAPI = siteUrl + "/apiadmin/";

export const apiVersion = "v9";
export const version = "9.0.0";
